import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  
  return (
    <footer className="relative py-16 px-6 border-t border-slate-800/50">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {/* Left: Brand */}
          <div className="space-y-4">
            <img 
              src="https://static.readdy.ai/image/584ac40951726429431482b4d17e4edf/ff958525ef19bccc41cd8ac8f6d5e333.png" 
              alt="Scroll Companion Logo" 
              className="h-10 w-auto"
            />
            <p className="text-slate-400 max-w-md">
              {t('footer.description')}
            </p>
          </div>

          {/* Right: Contact */}
          <div className="space-y-4 md:text-right">
            <h3 className="text-lg font-semibold text-white">{t('footer.contact')}</h3>
            <a 
              href="mailto:nofficestudio@gmail.com"
              className="block text-teal-400 hover:text-teal-300 transition-colors cursor-pointer"
            >
              nofficestudio@gmail.com
            </a>
            <div className="flex gap-4 md:justify-end">
              <a href="#" className="text-slate-400 hover:text-white transition-colors cursor-pointer">
                {t('footer.privacy')}
              </a>
              <span className="text-slate-700">|</span>
              <a href="#" className="text-slate-400 hover:text-white transition-colors cursor-pointer">
                {t('footer.terms')}
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800/50 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            {t('footer.copyright')}
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-slate-500 hover:text-teal-400 transition-colors text-sm cursor-pointer"
          >
            {t('footer.poweredBy')}
          </a>
        </div>
      </div>
    </footer>
  );
}
